export default {"src":"/_next/static/media/bloomberg_logo.d46c27b1.svg","height":96,"width":476,"blurWidth":0,"blurHeight":0};